"use client"

import { useTranslations } from 'next-intl'
import { IoIosCall } from 'react-icons/io'
import { MdEmail, MdLocationOn } from 'react-icons/md'

type Props = {
  className: string
}

const LetUsTalk = ({ className }: Props) => {
  const  t  = useTranslations()

  return (
    <div
      className={`${className} w-full rounded-lg bg-linear-to-r from-primary from-20% to-secondary px-8 py-20 text-white lg:pb-10 lg:pt-20`}
    >
      <p className='mb-4 text-lg uppercase'>{t('contactUs.contactUs')}</p>
      <h3 className='lg:mb-14s mb-10 text-2xl font-bold lg:text-3xl lg:leading-snug'>
        {t('contactUs.speakWithExpertEngineers')}
      </h3>
      <ul className='flex flex-col gap-10'>
        <li className='flex items-center gap-5'>
          <div className='rounded-full self-start bg-white p-3 text-primary'>
            <IoIosCall aria-label='phone-number' className='h-6 w-6' />
          </div>
          <div className='flex flex-col gap-1'>
            <p> {t('contactUs.phone')}</p>
            <a
              dir='ltr'
              href='tel:+963987233122'
              className='transition-all hover:opacity-50'
            >
              {t('contactInfo.number')}
            </a>
          </div>
        </li>
        <li className='flex items-center gap-5'>
          <div className='rounded-full self-start bg-white p-3 text-primary'>
            <MdEmail aria-label='email' className='h-6 w-6' />
          </div>
          <div className='flex flex-col gap-1'>
            <p> {t('contactUs.email')}</p>
            <a
              href='mailto:info@codehorizon.org'
              className='transition-all hover:opacity-50'
            >
              {t('contactInfo.companyEmail')}
            </a>
          </div>
        </li>
        <li className='flex items-center gap-5'>
          <div className='rounded-full self-start bg-white p-3 text-primary'>
            <MdLocationOn aria-label='location' className='h-6 w-6' />
          </div>
          <div className='flex flex-col gap-1'>
            <p> {t('contactUs.address')}</p>
            <p className='whitespace-pre-line'> {`${t('contactInfo.location')}\n${t('contactInfo.buildingNumber')}\n${t('contactInfo.officeNumber')}`}</p>
          </div>
        </li>
      </ul>
    </div>
  )
}

export default LetUsTalk
